import axios from 'axios'

function getBaseURL () {
  // if (process.env.VUE_ENV === 'client') {
  //   return '/api'
  // }
  if (process.env.NODE_ENV === 'development' || process.env.STAGE === 'test' || window.location.host.indexOf('aix-test-k8s.iweikan.cn') !== -1) {
    return 'http://soa-backend.aix-test-k8s.iweikan.cn'
    // return 'http://localhost:8000'
  }
  return 'https://cfjf-backend.zhhainiao.com'
}

let baseURL = getBaseURL()

// let token = window.localStorage.getItem('__soa_token__')

const instance = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    // Authorization: token,
    post: { 'Content-Type': 'application/json' }
  }
})

instance.interceptors.request.use(config => {
  config.data = {
    ...config.data
  }

  // if (process.env.NODE_ENV === 'development' || process.env.VUE_ENV === 'server') {
  //   console.log('request:', config.url, config.data)
  // }

  return config
})

function handleErrorResponse (res) {
  // switch (res.ret) {
  //   // case 4001004:
  //   // case 4001002:
  //   //   if (typeof window !== 'undefined') {
  //   //     window.app.$store.dispatch('user/showLoginModal')
  //   //   }
  //   //   break
  //   default:
  //     // if (retCodeMap[res.ret] || res.msg) {
  //     //   toast(retCodeMap[res.ret] || res.msg)
  //     // }
  // }
  res = null
}

let errorHandleTimer

function generateErrorResponse (res) {
  errorHandleTimer = setTimeout(() => {
    if (!res.handled) {
      handleErrorResponse(res)
    }
  }, 10)
  const ret = res.ret
  Object.defineProperty(res, 'ret', {
    get () {
      clearTimeout(errorHandleTimer)
      return ret
    }
  })
  return res
}

instance.interceptors.response.use(res => {
  const data = res.data
  if (data.ret !== 0 && !data.data) {
    return Promise.reject(generateErrorResponse(data))
  }

  return data
}, err => {
  // if (process.env.VUE_ENV === 'server') {
  //   console.log('request error:', err)
  // }
  return Promise.reject(err)
})

export default instance
